import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { SuiviTuteurDetailPage, SuiviTuteurListPage } from ".";

export interface SuiviTuteurProps {}

export const SuiviTuteur: React.FunctionComponent<SuiviTuteurProps> = props => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviTuteurListPage />
      </Route>
      <Route path={`${match.path}/:suiviId?`} component={SuiviTuteurDetailPage} exact />
    </Switch>
  );
};
